export class VisitorPlace {
  public _id: string;
  public id: string;
  public hubName: string;
  public feedId: string;
  public isApproved: boolean;
  public isOwned: boolean;
  public isRemoved: boolean;
  public isPermanentlyClosed: boolean;
  public lat: number;
  public lng: number;
  public likes: number;
  public checkins: number;
  public rating: number;
  public user_ratings_total: number;
  public title: string;
  public name: string;
  public phone: string;
  public emails: string;
  public category: string;
  public categoryText?: string;
  public priceRange: string;
  public website: string;
  public categoryList: string[];
  public blacklisted: boolean;

  public image?: string;
  public imageLink?: string;
  public imageFile: File;
  public _360VideoKey?: string;
  public youtubeLink?: string;
  public facebookLink?: string;
  public address?: {
    address: string;
    lat: number;
    lng: number;
    addressComponents: {
      long_name: string;
      short_name: string;
      types: string[];
    }[];
  };
  public address_components?: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
  public attendingCount?: number;
  public isChoice?: boolean;
  public isCustom?: boolean;
  public isToBeExport?: boolean;
  public pinnedTime: Date;

  public hostFacebookLink?: string;
  public hostGoogleLink?: string;
  public ticketUri?: string;
  public description?: string;
  public about?: string;

  public owner: {
    name: string;
  };
  public startTimeFormatted: string;
  public endTimeFormatted: string;
  public isManuallyCreated: boolean;
  public isHubCreated: boolean;
  public isPromotionImage: boolean;
  public isFacebookEvent: boolean;
  public hostLink: string;
  public ownerEmail: string;
  public eventLink: string;
  public promotionLink: string;
  public cover: {
    source: string;
    isDefault: boolean;
  };

  public startTime?: string;
  public endTime?: string;
  public eventTimes?: any[];
  public startTimeText?: string;
  public endTimeText?: string;
  public eventTimesText?: any[];
  public timezone?: string;
  public mapIcon?: string;
  public hours?: any[];
  public hoursText?: any[];

  public placeId?: string;
  public from?: string;
  public socialName?: string;
  public nameId?: string;

  public photos: {
    photo_reference: string; // for google places
  }[];
  public blockedGooglePhotos: string[];
  public allowedGooglePhotos: string[];
  public ownedPhotos: string[];

  public changeHistory: {
    userName: string;
    changedAt: string;
  }[];

  place_id: string;
  reviews: GooglePlaceReview[]; // load from Google place details API
  googleReviews: GooglePlaceReview[]; // load from database
  url: string;
  price_level: number; // pulled from google api
  opening_hours: OpeningHours;
  // photos: any[];
  photoSources: string[];
  appKey: string;
  business_status: string; // for google places, stands for if the place is open normally (OPERATIONAL), or CLOSED_TEMPORARILY or CLOSED_PERMANENTLY

  aerialVideo: {
    landscape: { url: string };
    portrait: { url: string };
  }; // for google Aerial video (360° video for Itinerary V3)

  // for V3 places, some new fields from Google places
  wheelchair_accessible_entrance: boolean;
  dine: {
    delivery: boolean | undefined;
    dine_in: boolean | undefined;
    serves_beer: boolean | undefined;
    serves_breakfast: boolean | undefined;
    serves_brunch: boolean | undefined;
    serves_dinner: boolean | undefined;
    serves_lunch: boolean | undefined;
    serves_wine: boolean | undefined;
    takeout: boolean | undefined;
    curbside_pickup: boolean | undefined;
  };

  // v3, when getting place details, the first image from Google place details API will be used as cover image. The old cover image is vague.
  // coverImage: string;

  isNotExistInSource: boolean; // a place might be removed from Google, this indicates if it is removed
  googleDetailsLoadedAt: string; // indicates when the place details was loaded from Google

  // provide client a function that they can edit place info, and lock them so that they can't be refreshed when updating the place from Google
  lock: {
    name: boolean;
    description: boolean;
    category: boolean;
    address: boolean;
    website: boolean;
    phone: boolean;
    priceRange: boolean;
    business_status: boolean;
    services: boolean;
  };

  audio: {
    link: string;
    description: string;
    isActive: boolean;
  };
}

export class PlaceAdditionalData {
  place_id: string;
  reviews: GooglePlaceReview[]; // load from Google place details API
  googleReviews: GooglePlaceReview[]; // load from database
  website: string;
  url: string;
  price_level: number; // pulled from google api
  priceRange: number; // user set in dashboard
  // priceLevelArray: {}[];
  user_ratings_total: number;
  opening_hours: OpeningHours;
  photos: {
    height: number;
    photo_reference: string;
    width: number;
    html_attributions: any;
  }[];
  // photos: any[];
  photoSources: string[];
  formatted_phone_number: string;
  phone: string;
  hostLink: string;
  allowedGooglePhotos: string[];
  blockedGooglePhotos: string[];
  appKey: string;
  business_status: string; // for google places, stands for if the place is open normally (OPERATIONAL), or CLOSED_TEMPORARILY or CLOSED_PERMANENTLY

  // for V3 places, some new fields from Google places
  wheelchair_accessible_entrance: boolean;
  dine: {
    delivery: boolean | undefined;
    dine_in: boolean | undefined;
    serves_beer: boolean | undefined;
    serves_breakfast: boolean | undefined;
    serves_brunch: boolean | undefined;
    serves_dinner: boolean | undefined;
    serves_lunch: boolean | undefined;
    serves_wine: boolean | undefined;
    takeout: boolean | undefined;
    curbside_pickup: boolean | undefined;
  };

  // v3, when getting place details, the first image from Google place details API will be used as cover image. The old cover image is vague.
  // coverImage: string;

  isNotExistInSource: boolean; // a place might be removed from Google, this indicates if it is removed
}

export class GooglePlaceReview {
  author_name: string;
  author_url: string;
  language: string;
  profile_photo_url: string;
  rating: number;
  stars: any[];
  relative_time_description: string;
  text: string;
  time: number;
  dateTimeISOString: string;
  url: string;
  photos: {
    url: string;
  }[];
}

export class OpeningHours {
  open_now: boolean;
  periods: {
    open: {
      day: number;
      time: string;
    };
    close: {
      day: number;
      time: string;
    };
  }[];
  weekday_text: string[];
}

export enum PlaceBusinessStatus {
  OPERATIONAL = 'OPERATIONAL',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  CLOSED_PERMANENTLY = 'CLOSED_PERMANENTLY',
}
